import React from "react";

export function ChatCTA() {
  return (
    <div className="mb-3 max-w-[920px] animate-[fadeUp_.6s_cubic-bezier(.16,1,.3,1)]">
      <div className="inline-flex items-center gap-2 rounded-full border border-accent/20 bg-accent/10 px-4 py-2 text-[13px] font-semibold text-accent">
        <span className="h-2 w-2 rounded-full bg-accent pulse-dot" />
        Studio de génération
      </div>
      <p className="mt-5 font-display text-[42px] font-bold leading-[1.02] tracking-[-0.06em] text-foreground lg:text-[56px]">
        Que créons-nous<br />aujourd'hui&nbsp;?
      </p>
      <p className="mt-4 max-w-[560px] text-[17px] leading-8 text-secondary">
        Choisissez un module, donnez le vin, laissez vinIA écrire la suite.
      </p>
    </div>
  );
}